export default {
  appEnvironment: process.env.NODE_ENV,
  mixpanelToken: window.MIXPANEL_TOKEN,
  railsEnv: window.RAILS_ENV,
  flagsmithApiUrl: window.FLAGSMITH_API_URL,
  flagsmithEnvironmentKey: window.FLAGSMITH_ENVIRONMENT_KEY,
};
